import React, { useRef, useEffect } from "react";
import "../../signin/tutorSignin.css";
import {
  Col,
  Row,
  Typography,
  Layout,
  Button,
  Image,
} from "antd";
import { useNavigate, useLocation } from "react-router";
import { Post } from "../../../config/api/post";
import { ASSOCIATE_AUTH } from "../../../config/constants/api";
import swal from "sweetalert";
import { ImageUrl } from "../../../helpers/Functions";

function AssociateForgotPassword2() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const input1 = useRef();
  const input2 = useRef();
  const input3 = useRef();
  const [loading, setLoading] = React.useState(false);
  const [codeData, setCodeData] = React.useState({
    input1: "",
    input2: "",
    input3: "",
    input4: "",
  });

  useEffect(() => {
    if (!state?.email) {
      navigate("/associate/forgot-password", { replace: true });
    }
  }, [state, navigate]);

  const onFinish = () => {
    const code =
      codeData.input1 + codeData.input2 + codeData.input3 + codeData.input4;

    if (!codeData.input1 || !codeData.input2 || !codeData.input3 || !codeData.input4) {
      swal("Error", "Please enter the complete verification code", "error");
      return;
    }

    setLoading(true);
    Post(ASSOCIATE_AUTH.verifyCode, { code, email: state.email })
      .then((response) => {
        setLoading(false);
        if (response?.data?.status) {
          swal("Success", response?.data?.message, "success");
          navigate("/associate/forgot-password-3", {
            replace: true,
            state: { code, email: state.email },
          });
        } else {
          swal(
            "Oops!",
            response?.data?.message || response?.response?.data?.message,
            "error"
          );
        }
      })
      .catch(() => {
        swal("Oops!", "Unable to verify code", "error");
        setLoading(false);
      });
  };

  const handleInputChange = (name, value) => {
    setCodeData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Layout className="AuthBackground tutorSigninLayout" style={{ minHeight: "100vh" }}>
      <Row className="tutorSigninRow" gutter={[0, 0]}>
        <Col xs={24} lg={12} className="tutorSigninFormCol">
          <div className="tutorSigninFormShell">
            <div className="tutorSigninFormCard">
              <Image
                src={ImageUrl("fav.png")}
                className="tutorSigninLogo"
                alt="WrightCo Academy"
                preview={false}
              />
              <Typography.Title level={2} className="fontFamily1 tutorSigninTitle">
                Verify code
              </Typography.Title>
              <Typography.Paragraph className="tutorSigninSubtitle">
                Enter the 4-digit verification code sent to {state?.email}.
              </Typography.Paragraph>

              <Row gutter={10} style={{ marginBottom: 24 }}>
                <Col>
                  <input
                    autoFocus
                    type="text"
                    maxLength={1}
                    className="codeInput"
                    onChange={(e) => {
                      input1.current?.focus();
                      handleInputChange("input1", e.target.value);
                    }}
                  />
                </Col>
                <Col>
                  <input
                    type="text"
                    maxLength={1}
                    className="codeInput"
                    ref={input1}
                    onChange={(e) => {
                      input2.current?.focus();
                      handleInputChange("input2", e.target.value);
                    }}
                  />
                </Col>
                <Col>
                  <input
                    type="text"
                    maxLength={1}
                    className="codeInput"
                    ref={input2}
                    onChange={(e) => {
                      input3.current?.focus();
                      handleInputChange("input3", e.target.value);
                    }}
                  />
                </Col>
                <Col>
                  <input
                    type="text"
                    maxLength={1}
                    className="codeInput"
                    ref={input3}
                    onChange={(e) => handleInputChange("input4", e.target.value)}
                  />
                </Col>
              </Row>

              <Button
                type="primary"
                className="loginButton tutorSigninSubmit"
                block
                onClick={onFinish}
              >
                {loading ? "Loading..." : "Continue"}
              </Button>

              <Typography.Text
                className="tutorSigninFooterText fontFamily1"
                style={{ display: "block", marginTop: 16 }}
              >
                <span
                  className="tutorSigninRegisterLink"
                  role="button"
                  tabIndex={0}
                  onClick={() => navigate("/associate/signin")}
                >
                  Back to associate login
                </span>
              </Typography.Text>
            </div>
          </div>
        </Col>
        <Col xs={0} lg={12} className="tutorSigninPromoCol">
          <div className="tutorSigninPromoBg" aria-hidden />
          <div className="tutorSigninPromoContent">
            <Typography.Title level={2} className="tutorSigninPromoTitle">
              Check your email
            </Typography.Title>
            <Typography.Paragraph className="tutorSigninPromoSubtitle">
              Enter the verification code we sent to confirm your identity.
            </Typography.Paragraph>
          </div>
        </Col>
      </Row>
    </Layout>
  );
}

export default AssociateForgotPassword2;
